module.exports = __webpack_public_path__ + "staticVue/img/tipIcon.1df86e5c.png";